import React from 'react';

interface ISelect {
    values: { value: string; display: string }[];
    placeholder: string;
    value?: string;
    onChange: (_: any) => void;
    onBlur: () => void;
    'data-testid'?: string;
}

const Select = ({
    values,
    placeholder,
    value = '',
    onChange,
    onBlur,
    'data-testid': dataTestId,
}: ISelect) => {
    let valueToDisplay = value;
    const optionMatch = values.find(
        ({ value: optionValue }) => optionValue === value,
    );

    if (optionMatch && optionMatch.display) {
        valueToDisplay = optionMatch.display;
    } else if (placeholder) {
        valueToDisplay = placeholder;
    }

    return (
        <div className="eds-field-annotation eds-field-annotation--success">
            <div className="eds-select">
                <label
                    className="eds-select__value"
                    data-testid="value-to-display"
                >
                    {valueToDisplay}
                    <span className="eds-select__icon">
                        <i className="eds-vector-image eds-icon--small eds-vector-image--grey-600">
                            <svg viewBox="0 0 24 24">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7 10.2l5 5 5-5-1.4-1.4-3.6 3.6-3.6-3.6z"
                                />
                            </svg>
                        </i>
                    </span>
                </label>
                <select
                    className="eds-select__input"
                    onChange={(e) => onChange(e.target.value)}
                    onBlur={() => onBlur()}
                    data-testid={dataTestId}
                    value={value}
                >
                    {placeholder ? (
                        <option disabled>{placeholder}</option>
                    ) : undefined}
                    {values.map((item) => (
                        <option key={item.value} value={item.value}>
                            {item.display}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default Select;
